import gql from 'graphql-tag';

import { DEFAULT_PRICE_RANGE_BANDS } from '@dutchie/common/utils/price-range-bands';

import { useQuery } from 'src/hooks/use-query';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

// Uses the server's priceRangeFilterSettings, which resolves the rollout flag. No bands are
// returned until the query resolves successfully: rendering DEFAULT_PRICE_RANGE_BANDS during
// loading would flash the filter on dispensaries where the feature is off.
export const priceRangeFilterSettingsQuery = gql`
  query PriceRangeFilterSettings($dispensaryId: String!) {
    priceRangeFilterSettings(dispensaryId: $dispensaryId) {
      enabled
      bands {
        bandId
        label
        min
        max
      }
    }
  }
`;

export default function usePriceRangeBands() {
  const { dispensary } = useDispensary();

  const { data, loading, error } = useQuery(priceRangeFilterSettingsQuery, {
    variables: { dispensaryId: dispensary?.id },
    skip: !dispensary?.id,
  });

  const settings = data?.priceRangeFilterSettings;

  if (loading || error || settings?.enabled === false) {
    return { enabled: false, bands: [], loading, error };
  }

  return {
    enabled: true,
    bands: settings?.bands?.length ? settings.bands : DEFAULT_PRICE_RANGE_BANDS,
    loading,
    error,
  };
}
